export default {
  en: {
    choose_emoji: 'Choose emoji',
  },
};
